export const DcMethodValues = {
  ACCOUNT_MANAGEMENT: 'Account Management Page',
  MEMBERSHIP_DETAIL: 'Membership Detail Page',
  USER_DETAIL: 'User Detail Page',
  ADD_UPDATE_USER: 'Add/Update User Page',
  APPLICATIONS: 'Applications Page',
  ALL_SERVICES: 'All Services Page',
  DASHBOARD: 'Dashboard Page',
  PROFILE: 'Profile Page',
  ADD_BUSINESS: 'Add Business Page',
  SUCCESS_PAGE: 'Success Page',
  CHAMBER_ENTREPRENEURSHIP: 'Chamber Entrepreneurship Page',
  ATA_CARNET_REFUND: 'ATA Carnet Refund Page',
  MEDIATION: 'Mediation Page',
  INFORMATION_SERVICE: 'Information Service Page',
  MEMBERSHIP: 'Membership Page',
  MEMBERSHIP_CANCELLATION: 'Membership Cancellation Page',
  MANAGE_SIGNATORIES: 'Manage Signatories Page',
  SHARED_SERVICE: 'Shared Service',
  GENERAL: 'General Page',
} as const;
